import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../../common/form';

import { success } from '../../../../services/toastService';

class EquipmentInformationForm extends Form {
	state = {
		data: {
			instrument: 'EDDYFI',
			cableLength: 5,
			sizingAlgo: 'CWT applied if found any Isolated Corrosion',
			serialNumber: '1905716',
			insulationType: '',
			insulationThickness: '',
			footprint: '',
			model: '',
			probeSerialNumber: '',
			dateOfInspection: null,
			calibrationDueDate: null,
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		instrument: Joi.string().required().label('Instrument / Manufacturer'),
		cableLength: Joi.number().positive().min(1).required().label('Cable Length (M)'),
		sizingAlgo: Joi.string().min(3).required().label('Sizing Algorithm'),
		serialNumber: Joi.string().min(3).required().label('Serial Number'),
		model: Joi.string().required().label("Model"),
		footprint: Joi.string().required().label("Footprint"),
		probeSerialNumber: Joi.string().required().label("Probe Serial Number"),
		insulationType: Joi.string().required().label("Insulation Type"),
		insulationThickness: Joi.number().required().label("Insulation Thickness"),
		dateOfInspection: Joi.date().less('now').required().label('Date of Inspection'),
		calibrationDueDate: Joi.date().greater('now').required().label('Calibration Due Date'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
		initialData: PropTypes.object,
	};

	componentDidMount(): void {
		if (this.props.initialData) {
			this.setState({ data: this.props.initialData });
		}
	}

	doSubmit = (): void => {
		this.props.onProceed(this.state.data);
		success('Equipment Information saved successfully!');
	};
	

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="form-title">Equipment Information</div>

				<div className="my-4 divider"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'instrument',
							label: 'Instrument / Manufacturer',
							placeholder: 'Enter Instrument / Manufacturer',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'cableLength',
							label: 'Cable Length (M)',
							placeholder: 'Enter Cable Length (M)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'sizingAlgo',
							label: 'Sizing Algorithm',
							placeholder: 'Enter Sizing Algorithm',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'serialNumber',
							label: 'Serial Number',
							placeholder: 'Enter Serial Number',
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>
				
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'footprint',
							label: 'Footprint',
							placeholder: 'Enter Footprint',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'insulationType',
							label: 'Insulation Type',
							placeholder: 'Enter Insulation Type',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'insulationThickness',
							label: 'Insulation Thickness (mm)',
							placeholder: 'Enter Insulation Thickness',
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'model',
							label: 'Model',
							placeholder: 'Enter Model',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'probeSerialNumber',
							label: 'Probe Serial Number',
							placeholder: 'Enter Probe Serial Number',
						})}
					</div>

					<div className="col">
						{this.renderDatePicker({
							name: 'dateOfInspection',
							label: 'Date of Inspection',
							placeholderText: 'Select Date of Inspection',
							maxDate: new Date(),
						})}
					</div>
					
					<div className="col">
						{this.renderDatePicker({
							name: 'calibrationDueDate',
							label: 'Calibration Due Date',
							placeholderText: 'Select Calibration Due Date',
							minDate: new Date(),
						})}
					</div>
				</div>

				<div className="divider mt-4 mb-2 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Equipment Information')}
				</div>
			</form>
		);
	}
}

export default EquipmentInformationForm;